module.exports = __webpack_public_path__ + "img/apply-bg.e9afd0ba.png";